import { createSlice } from "@reduxjs/toolkit";
import { Chat } from "./types";

const initialStateValue: Chat = {
  isLogged: false,
  isLoading: false,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState: { value: initialStateValue },
  reducers: {
    setChat: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
  },
});

export const { setChat } = chatSlice.actions;
export default chatSlice.reducer;
